export const TAGPRODUTO_DELETA = "TAGPRODUTO_DELETA";
export const TAGAGRUPADOR_DELETA = "TAGAGRUPADOR_DELETA";
export const TAGPRODUTO_CREATE = "TAGPRODUTO_CREATE";
export const TAGAGRUPADOR_CREATE = "TAGAGRUPADOR_CREATE";
export const TAGPRODUTO_LOAD = "TAGPRODUTO_LOAD";
export const TAGAGRUPADOR_LOAD = "TAGAGRUPADOR_LOAD";
export const TAGPRODUTO_UPDATE = "TAGPRODUTO_UPDATE";
export const TAGAGRUPADOR_UPDATE = "TAGAGRUPADOR_UPDATE";
